import { useState } from "react";
import AttachmentManager from "./AttachmentManager.jsx";

const blank = {
  title: "",
  operationType: "Search Warrant",
  priority: "High",
  status: "Planning",
  location: "",
  objective: "",
  commander: "",
  teamLead: "",
  staging: "",
  operationDate: "",
  assignedOperators: "",
  equipment: "",
  safety: "",
  notes: "",
  attachments: []
};

export default function OperationModal({ operation, onClose, onSave }) {
  const [form, setForm] = useState({
    ...blank,
    ...(operation || {}),
    operationType: operation?.operationType || operation?.missionType || "Search Warrant",
    attachments: Array.isArray(operation?.attachments) ? operation.attachments : []
  });

  function update(field, value) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  function submit(e) {
    e.preventDefault();
    if (!form.title.trim()) return alert("Operation title is required.");
    onSave(form);
  }

  return (
    <div className="modal-backdrop">
      <form className="modal" onSubmit={submit}>
        <div className="section-head">
          <div>
            <h2>{operation ? "Edit Operation" : "Create Operation"}</h2>
            <p className="muted">Operations Board CRUD with planning, timeline, packet, attachments, and AAR linkage.</p>
          </div>
          <button type="button" onClick={onClose}>Close</button>
        </div>

        <div className="form-grid">
          <Field label="Operation Title" value={form.title} onChange={(v) => update("title", v)} />
          <Select label="Operation Type" value={form.operationType} onChange={(v) => update("operationType", v)} options={["Search Warrant", "Arrest Warrant", "GPS Placement", "Surveillance", "Barricaded Subject", "Dignitary / Security", "Reconnaissance", "High-Risk Apprehension", "Search Operation", "Containment", "Rural Tracking", "Agency Assist", "Training", "Other"]} />
          <Select label="Priority" value={form.priority} onChange={(v) => update("priority", v)} options={["Low", "Normal", "High", "Critical"]} />
          <Select label="Status" value={form.status} onChange={(v) => update("status", v)} options={["Draft", "Planning", "Approved", "Active", "Debrief", "Closed"]} />
          <Field label="Location" value={form.location} onChange={(v) => update("location", v)} />
          <Field label="Operation Date / Time" type="datetime-local" value={form.operationDate} onChange={(v) => update("operationDate", v)} />
          <Field label="Commander" value={form.commander} onChange={(v) => update("commander", v)} />
          <Field label="Team Lead" value={form.teamLead} onChange={(v) => update("teamLead", v)} />
        </div>

        <Text label="Objective" value={form.objective} onChange={(v) => update("objective", v)} />
        <Text label="Staging / Rally / Command Post" value={form.staging} onChange={(v) => update("staging", v)} />
        <Text label="Assigned Operators" value={form.assignedOperators} onChange={(v) => update("assignedOperators", v)} />
        <Text label="Equipment Needs" value={form.equipment} onChange={(v) => update("equipment", v)} />
        <Text label="Safety / Threat Notes" value={form.safety} onChange={(v) => update("safety", v)} />
        <Text label="Notes" value={form.notes} onChange={(v) => update("notes", v)} />

        <AttachmentManager
          label="Operation Attachments / Photos / PDFs"
          attachments={form.attachments}
          onChange={(next) => update("attachments", next)}
        />

        <div className="modal-actions">
          <button type="button" onClick={onClose}>Cancel</button>
          <button className="primary" type="submit">Save Operation</button>
        </div>
      </form>
    </div>
  );
}

function Field({ label, value, onChange, type = "text" }) {
  return (
    <label>
      <span>{label}</span>
      <input type={type} value={value || ""} onChange={(e) => onChange(e.target.value)} />
    </label>
  );
}

function Select({ label, value, onChange, options }) {
  return (
    <label>
      <span>{label}</span>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)}>
        {options.map((x) => <option key={x}>{x}</option>)}
      </select>
    </label>
  );
}

function Text({ label, value, onChange }) {
  return (
    <label className="full">
      <span>{label}</span>
      <textarea rows="3" value={value || ""} onChange={(e) => onChange(e.target.value)} />
    </label>
  );
}
